interface InputFieldProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  error?: string;
  touched?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  touched,
}) => (
  <div className="mb-4">
    <label className="block text-gray-700 font-semibold mb-2">{label}</label>
    <input
      type="text"
      className={`w-full p-3 border rounded-lg ${error && touched ? "border-red-500" : "border-gray-300"
        }`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={`Enter ${label.toLowerCase()}`}
    />
    {error && touched && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

export default InputField;
